module.exports = __webpack_public_path__ + "static/media/13.f0ac31be.jpg";